export default __webpack_public_path__ + "static/media/al-shariwi.658bff88.png";